import React, { useState, useRef, useEffect } from 'react';
import { Navbar, Nav, Container, Button, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Navbar.css';
import BookingForm from './BookingForm';

const NavigationBar = () => {
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const dropdownRef = useRef(null);
  const bookBtnRef = useRef(null);
  
  // Handle dropdown visibility
  const handleDropdownToggle = (isOpen) => {
    setShowDropdown(isOpen);
  };
  
  // Handle dropdown click for both mobile and desktop
  const handleDropdownClick = (e) => {
    if (window.innerWidth < 992) {
      e.preventDefault();
      e.stopPropagation();
      setShowDropdown(!showDropdown);
    } else {
      // For desktop, we don't prevent default navigation but we do close the dropdown
      setShowDropdown(false);
    }
  };

  const handleBookNow = () => {
    setShowBookingForm(true);
  };

  const handleCloseBooking = () => {
    setShowBookingForm(false);
  };

  // Effect to handle button color and dropdown behavior
  useEffect(() => {
    // Fix for button color changing after closing the form
    const handleButtonColor = () => {
      if (bookBtnRef.current) {
        bookBtnRef.current.style.backgroundColor = 'var(--accent-color)';
        bookBtnRef.current.style.border = 'none';
        bookBtnRef.current.style.color = 'var(--white-color)';
      }
    };
    
    // Apply the fix whenever the booking form is closed
    if (bookBtnRef.current) {
      handleButtonColor();
    }
    
    // Add event listeners for mobile dropdown
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showBookingForm]);
  
  return (
    <Navbar expand="lg" className="navbar-custom" fixed="top" expanded={expanded} onToggle={(e) => setExpanded(e)}>
      <Container>
        <Navbar.Brand as={Link} to="/" className="brand">
          <img src="/images/logo.png" alt="Portea Medical" className="logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)} />
        <Navbar.Collapse id="basic-navbar-nav" in={expanded}>
          <Nav className="ms-auto d-flex align-items-center">
            <NavDropdown 
              title="Our Services" 
              id="services-dropdown" 
              className="nav-link nav-item"
              show={showDropdown}
              onMouseEnter={() => handleDropdownToggle(true)}
              onMouseLeave={() => handleDropdownToggle(false)}
              onClick={handleDropdownClick}
              ref={dropdownRef}
            >
              <NavDropdown.Item as={Link} to="/services/nursing-attendants" onClick={() => {setShowDropdown(false); setExpanded(false);}}><span className="dropdown-icon"> 👩‍⚕️</span> Nursing Attendants</NavDropdown.Item>

              <NavDropdown.Item as={Link} to="/services/nursing-care" onClick={() => {setShowDropdown(false); setExpanded(false);}}><span className="dropdown-icon">👩‍⚕️</span> Nursing Care</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/services/care-giver" onClick={() => {setShowDropdown(false); setExpanded(false);}}><span className="dropdown-icon">👵</span> Care Giver</NavDropdown.Item>

              {/* <NavDropdown.Item href="#equipment"><span className="dropdown-icon"></span> Medical Equipment</NavDropdown.Item> */}
              <NavDropdown.Item as={Link} to="/services/mother-baby-care" onClick={() => {setShowDropdown(false); setExpanded(false);}}><span className="dropdown-icon">👶</span> Mother & Baby Care</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/services/physiotherapy" onClick={() => {setShowDropdown(false); setExpanded(false);}}><span className="dropdown-icon">🦵</span> Physiotherapy</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/services/doctor-consultation" onClick={() => {setShowDropdown(false); setExpanded(false);}}><span className="dropdown-icon">🩺</span> Doctor Consultation</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/services/icu-at-home" onClick={() => {setShowDropdown(false); setExpanded(false);}}><span className="dropdown-icon">🔬</span> ICU At Home</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/services/iv-injection" onClick={() => {setShowDropdown(false); setExpanded(false);}}><span className="dropdown-icon"> 💉</span> IV & IM Injection</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/services/lab-tests" onClick={() => {setShowDropdown(false); setExpanded(false);}}><span className="dropdown-icon">🧪</span> Lab Tests</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/services/parkinsons-care" onClick={() => {setShowDropdown(false); setExpanded(false);}}><span className="dropdown-icon"> 🧠</span> Parkinson's Care</NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={Link} to="/about" className="nav-link" onClick={() => setExpanded(false)}>About Us</Nav.Link>
            <Nav.Link as={Link} to="/equipment" className="nav-link" onClick={() => setExpanded(false)}>Equipments</Nav.Link>
            <Nav.Link as={Link} to="/career" className="nav-link" onClick={() => setExpanded(false)}>Careers</Nav.Link>
            <Nav.Link as={Link} to="/contact" className="nav-link" onClick={() => setExpanded(false)}>Contact</Nav.Link>
            <Nav.Link href="tel:+918709530016" className="nav-link phone-link">
              <i className="phone-icon">📞</i> +91 8709530016
            </Nav.Link>
            <Button 
              onClick={handleBookNow} 
              className="book-now-btn"
              ref={bookBtnRef}
            >Book Now</Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
       <BookingForm 
        show={showBookingForm} 
        handleClose={handleCloseBooking} 
        defaultService="Care Giver"
         />
    </Navbar>
  );
};

export default NavigationBar;
